import { render, staticRenderFns } from "./feixeGauss.vue?vue&type=template&id=233f2936&"
import script from "./feixeGauss.vue?vue&type=script&lang=js&"
export * from "./feixeGauss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports